import React, { cloneElement } from "react";
import { Container } from "components/shared";
import { Card } from "components/ui";
import Logo from "components/template/logo";
import { useSelector } from "react-redux";

const Layout = ({ children, content, ...rest }) => {
  const themeColor = useSelector((state) => state?.theme?.themeColor);
  const primaryColorLevel = useSelector(
    (state) => state?.theme?.primaryColorLevel
  );
  return (
    <div className={`bg-${themeColor}-${primaryColorLevel} min-h-screen h-full`}>
      <Container className="flex flex-col flex-auto items-center justify-center min-w-0 h-full px-4 py-8 sm:py-12">
        <Card
          className="w-full max-w-[480px] sm:max-w-[520px] min-h-[520px] sm:min-h-[560px] rounded-2xl shadow-xl"
          bodyClass="p-6 sm:p-8 md:p-10"
        >
          <div className="text-center mb-2">
            <img
              src="/trainerx.png"
              alt="TrainerX"
              className="mx-auto"
              style={{ height: 36, width: "auto", objectFit: "contain" }}
            />
          </div>
          <div>
            {content}
            {children
              ? cloneElement(children, {
                contentClassName: "text-center",
                ...rest,
              })
              : null}
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default Layout;
